import React from 'react'

export default function Monitor() {
    return (
        <div>
           <h1>
           This is Monitor page dummy content
           </h1>
           <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Natus, aut. Iste omnis consectetur molestiae voluptatibus. Tempora totam quaerat dolorum sint.</p>
        </div>
    )
}
